import React, { RefObject, useEffect, useRef } from 'react';
import { useDateRangeValidation } from './useDateRangeValidation';
import { Row } from '../../grid/Row/Row';
import { Input } from '../Input/Input';
import { RowModifier } from '../../grid/Row/Row';

type BasicControlledRange = {
  start: any;
  end: any;
  labelStart: string;
  labelEnd: string;
  onBlurStart?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onBlurEnd?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onChange?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  dateRangeTypeDependentValidation?: (
    startRef: RefObject<HTMLInputElement | null>,
    endRef: RefObject<HTMLInputElement | null>
  ) => void;
};

const normalizeValue = (type: 'date' | 'datetime' | 'datetime-local' | 'time' | undefined, value?: string) => {
  return type === 'date' ? value?.split('T')[0] : value;
};

/**
 * Date Range to switch between date-time and datetime-local types.
 *
 * value here is always given in datetime-local format from BE.
 * TODO: need to keep time somewhere in state so we dont lose input while switching.
 */
export function BasicControlledRange({
  labelStart,
  labelEnd,
  start,
  end,
  onBlurStart,
  onBlurEnd,
  onChange,
  dateRangeTypeDependentValidation,
}: BasicControlledRange) {
  const startRef = useRef<HTMLInputElement>(null);
  const endRef = useRef<HTMLInputElement>(null);

  const validation = useDateRangeValidation(startRef, endRef, dateRangeTypeDependentValidation);

  useEffect(() => {
    validation();
  }, [start.value, end.value, validation]);

  return (
    <Row modifier={RowModifier.GRID_2_COLUMNS}>
      <Input
        label={labelStart}
        param={start}
        ref={startRef}
        onBlur={typeof onBlurStart === 'function' ? onBlurStart : undefined}
        value={normalizeValue(start?.type, start?.value)}
        onChange={onChange}
      />
      <Input
        label={labelEnd}
        param={end}
        ref={endRef}
        onBlur={onBlurEnd}
        value={normalizeValue(end?.type, end?.value)}
        onChange={onChange}
      />
    </Row>
  );
}
